module.exports = __webpack_public_path__ + "statics/img/5-4.13b0a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/5-4.png
// module id = WCt4
// module chunks = 1